import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { Row, Button } from "antd";
import { UserOutlined } from "@ant-design/icons";
import videoBg from "../assets/bucket_wheel.mp4";
import "./signIn.css";

const SignIn = () => {
  const { instance } = useMsal();

  const handleLogin = () => {
    const loginType = (import.meta.env.VITE_MSAL_LOGIN_TYPE || "redirect").toLowerCase();
    if (loginType === "popup") {
      instance.loginPopup(loginRequest).catch(console.error);
    } else {
      instance.loginRedirect(loginRequest);
    }
  };

  return (
    <Row style={{ height: "calc(100vh - 46px)" }} align="middle" justify="center">
      <div className="signon">
        <form>
              
              <div >
          <Button
            className="buttonHover"
            ghost
            type="default"
            icon={<UserOutlined />}
            style={{
                    //borderRadius: 5,
              fontWeight: "bold",
              fontSize: 36,
              color: "white",
                    paddingTop:0,
                    paddingBottom: 0,
              marginTop: 5,
              marginBottom: 5,
              height: 70,
            }}
            onClick={handleLogin}
          >
            Sign In
          </Button>
              </div>
        </form>
      </div>
      <video src={videoBg} autoPlay muted loop />
      <div className="overlay"></div>
    </Row>
  );
};

export default SignIn;
